export class MetaDataRevolution {
    icon?: string;
    type?: string;
    badge?: string;
    route?: string;
    parent?: string;
    badgeColor?: string;
    customClass?: string;
    pathMatchExact: boolean = false;
    constructor() {
        this.parent = '';
        this.route = '';
    }
    jsonModel(json: any){
        this.icon = (json.icon) ? json.icon : null;
        this.type = (json.type) ? json.type : null;
        this.badge = (json.badge) ? json.badge : null;
        this.route =(json.route) ? json.route : null;
        this.parent =(json.parent) ? json.parent : null;
        this.badgeColor =(json.badgeColor) ? json.badgeColor : null;
        this.customClass = (json.customClass) ? json.customClass : null;
        this.pathMatchExact = json.pathMatchExact; 
    }
}

export class MetaRoles {
    id: string = '';
    name: string = '';
    constructor(d: any) {
        this.jsonModel(d);
    }
    jsonModel(json: any){
        this.id = (json.id) ? json.id : null;
        this.name = (json.name) ? json.name : null;
    }
}

export class MenuRevolution {
    id?: number = 0;
    name?: string;
    description?: string;
    type?: string;
    parentId?: number = 0;
    position?: number = 0;
    metadata: MetaDataRevolution = new MetaDataRevolution();
    isActive: boolean = true;
    subMenuItems: MenuRevolution[] = [];
    parent: MenuRevolution | null = null;
    roles: MetaRoles[] = [];
    rolIds: string[] = [];
    constructor(d: any) {
        this.jsonModel(d);
        this.setParentsRecursively(null); 
    }
    jsonModel(json: any){
        this.id = (json.id) ? json.id : 0;
        this.name = (json.name) ? json.name : null;
        (json.metadata) ? this.metadata.jsonModel(json.metadata) : this.metadata.jsonModel(new MetaDataRevolution());
        this.description = (json.description) ? json.description : null;
        this.type = (json.type) ? json.type : null;
        this.position = (json.position) ? json.position : 0;
        this.parentId = (json.parentId) ? json.parentId : 0;
        this.isActive = json.isActive;
        this.roles = (json.roles) ? json.roles : [];
        if (json.roles) {
            this.roles = [];
            this.rolIds = [];
            json.roles.forEach((x: any) => {
                const subMenu = new  MetaRoles(x);
                this.roles.push(subMenu);
                this.rolIds.push(subMenu.id)
            });
        } else {
            this.roles = [];
            this.rolIds = [];
        }
        if (json.subMenuItems) {
            this.subMenuItems = [];
            json.subMenuItems.forEach((x: any) => {
                const subMenu = new MenuRevolution(x);
                this.subMenuItems.push(subMenu);
            });
            this.subMenuItems.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
        } else {
            this.subMenuItems = [];
        }
    }
    setParentsRecursively(parent: MenuRevolution | null = null) {
        this.parent = parent;
        this.subMenuItems.forEach(child => child.setParentsRecursively(this));
    }
}

export class UserMenuRevolution {
    userName?: string;
    userEmail?: string;
    isUserActive: boolean = true;
    isRoleActive: boolean = true;
    roleName?: string;
    menuItems: MenuRevolution[] = [];

    constructor(d: any) {
        this.jsonModel(d);
    }

    jsonModel(json: any){
        this.userName = (json.userName) ? json.userName : 0;
        this.userEmail = (json.userEmail) ? json.userEmail : null;
        this.isRoleActive = json.isRoleActive;
        this.isUserActive = json.isUserActive;
        this.roleName = (json.roleName) ? json.roleName : null;
        if (json.menuItems) {
            this.menuItems = [];
            json.menuItems.forEach((x: any) => {
                const subMenu = new MenuRevolution(x);
                this.menuItems.push(subMenu);
            });
        } else {
            this.menuItems = [];
        }
    }
}